import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, handlePaste } from '../../CommonUtils/CommonValidations';
import * as Yup from 'yup';
import { ERROR_MSG, MOBILE_VALIDATION, PINCODE } from '../../CommonUtils/contextVariables';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import { getDistricts, getMandals, getVillages } from '../../Reducers/AffiliationCommonservice';
import { useDispatch, useSelector } from 'react-redux';

export default function AfflUnivContact() {
    const hasFetchedData = useRef(false);
    const acYear = sessionStorage.getItem('ac_year');
    const districtmst = useSelector((state) => state?.commonMastersReducer?.DistList);
    const mandalmst = useSelector((state) => state?.commonMastersReducer?.mandalList);
    const villagemst = useSelector((state) => state?.commonMastersReducer?.villageList);
    const dispatch = useDispatch();
    const AfflUnivContactsValidation = Yup.object().shape({
        ubName: Yup.string().required(ERROR_MSG).nullable(),
        vcName: Yup.string().required(ERROR_MSG).nullable(),
        registarName: Yup.string().required(ERROR_MSG).nullable(),
        deanName: Yup.string().required(ERROR_MSG).nullable(),
        deanMobile: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid mobile number").nullable(),
        deanEmail: Yup.string().required(ERROR_MSG).nullable(),
        website: Yup.string().required(ERROR_MSG).nullable(),
        address: Yup.string().required(ERROR_MSG).nullable(),
        email: Yup.string().required(ERROR_MSG),
        phone: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid mobile number").nullable(),
        // faxNo: Yup.string().required(ERROR_MSG).matches(faxRegex, "Invalid Fax number").nullable(),
        pinCode: Yup.string().required(ERROR_MSG).matches(PINCODE, "Invalid Pincode").nullable(),
        district: Yup.string().required(ERROR_MSG),
        mandal: Yup.string().required(ERROR_MSG),
        village: Yup.string().required(ERROR_MSG),
    })
    const afflUnivContactsFormik = useFormik({
        initialValues: {
            ubName: "",
            vcName: "",
            registarName: "",
            deanName: "",
            deanMobile: "",
            deanEmail: "",
            website: "",
            address: "",
            email: "",
            phone: "",
            faxNo: "",
            pinCode: "",
            district: "",
            mandal: "",
            village: "",
            acYear: acYear,
            Beneficiary: "",
        },
        enableReinitialize: true,

        validationSchema: AfflUnivContactsValidation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveCdcContacts`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetUnivContactsData();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                }
            });
        }
    })
    const [univData, setunivData] = useState([]);
    function GetUnivContactsData() {
        let url = config.url.API_URL + "getCdcContacts";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setunivData(res?.data?.getCdcContacts)
                afflUnivContactsFormik?.setFieldValue("ubName", res?.data?.getCdcContacts[0]?.ub_name);
                afflUnivContactsFormik?.setFieldValue("vcName", res?.data?.getCdcContacts[0]?.vc_name);
                afflUnivContactsFormik?.setFieldValue("registarName", res?.data?.getCdcContacts[0]?.registrar_name);
                afflUnivContactsFormik?.setFieldValue("deanName", res?.data?.getCdcContacts[0]?.dean_name);
                afflUnivContactsFormik?.setFieldValue("deanMobile", res?.data?.getCdcContacts[0]?.dean_mobile);
                afflUnivContactsFormik?.setFieldValue("deanEmail", res?.data?.getCdcContacts[0]?.dean_email);
                afflUnivContactsFormik?.setFieldValue("website", res?.data?.getCdcContacts[0]?.u_website);
                afflUnivContactsFormik?.setFieldValue("address", res?.data?.getCdcContacts[0]?.u_address);
                afflUnivContactsFormik?.setFieldValue("email", res?.data?.getCdcContacts[0]?.u_email);
                afflUnivContactsFormik?.setFieldValue("phone", res?.data?.getCdcContacts[0]?.u_phone_no);
                afflUnivContactsFormik?.setFieldValue("faxNo", res?.data?.getCdcContacts[0]?.u_fax_no);
                afflUnivContactsFormik?.setFieldValue("pinCode", res?.data?.getCdcContacts[0]?.u_pincode);
                getDistricts(res?.data?.getCdcContacts[0]?.u_district)
                afflUnivContactsFormik?.setFieldValue("district", res?.data?.getCdcContacts[0]?.u_district);
                getMandals(res?.data?.getCdcContacts[0]?.u_district, dispatch);
                afflUnivContactsFormik?.setFieldValue("mandal", res?.data?.getCdcContacts[0]?.u_mandal);
                getVillages(res?.data?.getCdcContacts[0]?.u_district, res?.data?.getCdcContacts[0]?.u_mandal, dispatch)
                afflUnivContactsFormik?.setFieldValue("village", res?.data?.getCdcContacts[0]?.u_village)
                afflUnivContactsFormik?.setFieldValue("Beneficiary", res?.data?.getCdcContacts[0]?.bank_acc_no);

            } else {
                setunivData([]);


            }
        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            getDistricts();
            GetUnivContactsData();

            hasFetchedData.current = true
        }
    }, [])

    return (
        <>
            <CommonFormHeading heading="University Contact Address Updation for Affiliation" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={afflUnivContactsFormik}>
                    <Form onChange={afflUnivContactsFormik?.handleChange} onSubmit={afflUnivContactsFormik?.handleSubmit} className="affl-form">
                        <bie.Row className="px-2 pt-3 mb-3" >
                            <bie.Alert variant='danger' className='affl-alert'>
                                <div>
                                    <p className='mb-0'>
                                        Note: Below details
                                        reflect in Affiliation Order
                                        and are also
                                        required for Other Forms.
                                    </p>
                                </div>
                            </bie.Alert>
                            <bie.Row className='px-3 my-3'>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>University Name	</label>
                                    <Field type="text" name="ubName" className="form-control mb-2" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }} maxLength="80" />
                                    <ErrorMessage name="ubName" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} >
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>Vice-Chancellor Name</label>
                                    <Field type="text" name="vcName" className="form-control mb-2" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }} maxLength="80" />
                                    <ErrorMessage name="vcName" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>Registrar Name		</label>
                                    <Field type="text" name="registarName" className="form-control mb-2" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }} maxLength="80" />
                                    <ErrorMessage name="registarName" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} >
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>CDC Dean Name</label>
                                    <Field type="text" name="deanName" className="form-control mb-2" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }} maxLength="80" />
                                    <ErrorMessage name="deanName" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>CDC Dean E-Mail	</label>
                                    <Field type="email" name="deanEmail" className="form-control mb-2" />
                                    <ErrorMessage name="deanEmail" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} >
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>CDC Dean Mobile</label>
                                    <Field type="text" name="deanMobile" className="form-control mb-2" onKeyPress={(e) => { allowNumbersOnly(e) }}
                                        onPaste={(e) => handlePaste(e)} maxLength={10} />
                                    <ErrorMessage name="deanMobile" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>


                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup > */}
                                    <label className='mb-1'> <b style={{ color: 'red' }}>* </b>District  </label>
                                    <Field as="select" name="district" className="form-control mb-2" onChange={(e) => {
                                        getMandals(e.target.value, dispatch);
                                        afflUnivContactsFormik?.setFieldValue("mandal", "")
                                        afflUnivContactsFormik?.setFieldValue("village", "");
                                        dispatch({ type: "MANDALSLIST", payload: [] });
                                        dispatch({ type: "VILLAGESLIST", payload: [] });
                                    }} >
                                        <option value=''>--SELECT--</option>
                                        {districtmst && districtmst?.map((dd, i) => (
                                            <option value={dd?.dist_code} key={i}>{dd?.dist_name}</option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="district" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup > */}
                                    <label className='mb-1'> <b style={{ color: 'red' }}>* </b>Mandal  </label>
                                    <Field as="select" name="mandal" className="form-control mb-2" onChange={(e) => {
                                        getVillages(afflUnivContactsFormik?.values?.district, e.target.value, dispatch)
                                        afflUnivContactsFormik?.setFieldValue("village", "");
                                        dispatch({ type: "VILLAGESLIST", payload: [] });
                                    }}>
                                        <option value=''>--SELECT--</option>
                                        {mandalmst && mandalmst?.map((mm, i) => (
                                            <option value={mm?.mandal_code} key={i}>{mm?.mandal_name}</option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="mandal" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup > */}
                                    <label className='mb-1'> <b style={{ color: 'red' }}>* </b>Village   </label>
                                    <Field as="select" name="village" className="form-control mb-2" >
                                        <option value=''>--SELECT--</option>
                                        {villagemst && villagemst?.map((vv, i) => (
                                            <option value={vv?.village_code} key={i}>{vv?.village_name}</option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="village" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>Pincode</label>
                                    <Field type="text" name="pinCode" className="form-control mb-2" onKeyPress={(e) => { allowNumbersOnly(e) }}
                                        onPaste={(e) => handlePaste(e)} maxLength={6} />
                                    <ErrorMessage name="pinCode" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>University Address	</label>
                                    <Field as="textarea" name="address" className="form-control mb-2" maxLength="350" />
                                    <ErrorMessage name="address" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>University E-Mail	</label>
                                    <Field type="email" name="email" className="form-control mb-2" />
                                    <ErrorMessage name="email" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup > */}
                                    <label className='mb-1'> <b style={{ color: 'red' }}>* </b>University Phone	</label>
                                    <Field type="text" name="phone" className="form-control mb-2" onKeyPress={(e) => { allowNumbersOnly(e) }} maxLength={10} onPaste={(e) => handlePaste(e)} />

                                    <ErrorMessage name="phone" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>University Fax	</label>
                                    <Field type="text" name="faxNo" className="form-control mb-2" maxLength={18} />
                                    {/* <ErrorMessage name="faxNo" component="div" className="text-error" /> */}
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>University Website	</label>
                                    <Field type="text" name="website" className="form-control mb-2" />
                                    <ErrorMessage name="website" component="div" className="text-error" />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3}>
                                    {/* <bie.InputGroup> */}
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>Beneficiary A/c No. (Online Payment)	</label>
                                    <Field type="text" name="Beneficiary" className="form-control mb-2" disabled={true} />
                                    {/* </bie.InputGroup> */}
                                </bie.Col>
                            </bie.Row>

                            <div className="button-cend pt-1 mb-3">
                                <button type="submit" className="btn btn-success mt-2 float-end mb-2">
                                    Submit
                                </button>
                            </div>
                            {univData?.length > 0 && (<>
                                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0 ">Last Updated Status</h1></div>
                                <div className="table-responsive">

                                    <table className="table table-bordered table-striped affl-table">
                                        <thead> <tr>
                                            <th> Entered By</th>
                                            <th>Entered Date </th>


                                        </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-left" style={{ width: "30%" }}>{univData[0]?.ub_name}</td>
                                                <td className='cen'>{univData[0]?.entered_time}</td></tr>

                                        </tbody>
                                    </table>
                                </div>
                            </>)}
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    )
}
